// src/App.tsx
import { RouterProvider } from "react-router-dom";
import { router } from "./routes";
import RootLayout from "./layouts/RootLayout";
import { AuthProvider } from "./context/AuthContext";
import { TenantProvider } from "./context/TenantContext";
import { WorkflowTitleProvider } from "./context/WorkflowTitleContext";
import { DevToolsGuard } from "@/utils/devToolsGuard";
import { useEffect } from "react";
import { Analytics } from "@vercel/analytics/react";
import ErrorBoundary from "@/components/ErrorBoundary";

function App() {

  useEffect(() => {
    if (import.meta.env.VITE_ENABLE_DEVTOOLS_GUARD === 'true') {
      const devToolsGuard = new DevToolsGuard();
      devToolsGuard.enable();
      return () => devToolsGuard.disable();
    }
  }, []);

  return (
    <ErrorBoundary>
      <TenantProvider>
        <AuthProvider>
          <WorkflowTitleProvider>
            <RootLayout>
              <RouterProvider 
                router={router}
                future={{
                  v7_startTransition: true
                }}
              />
            </RootLayout>
          </WorkflowTitleProvider>
        </AuthProvider>
        <Analytics />
      </TenantProvider>
    </ErrorBoundary>
  );
}

export default App;
